import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import MultiSelect from "react-multi-select-component";
import {
    AreaChart,
    Area,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
} from "recharts";

import Merchant from "services/MerchantService";
import Emitter from "services/Emitter";
import Loading from "scenes/Loading";

/**
 * Renders daily volume charts
 * @component
 * @category Scenes
 * @subcategory Merchant
 */
class Volume extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.loadChart = this.loadChart.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.state = this.initialState();
    }

    initialState() {
        return {
            id: 0,
            loading: true,
            data: [],
            brands: [],
            brand: [{ label: "All", value: 0 }],
            brandSelectionEnabled: false,
            dailyTotal: [],
            dailyUnique: [],
        };
    }

    loadChart(brand = 0) {
        Merchant.dailyVolume(this.props.merchantId, brand).then((data) => {
            let days = Object.keys(data.total),
                unique = [],
                total = [];
            days.forEach((day) => {
                unique.push({
                    name: day,
                    total: data.unique[day],
                });
                total.push({
                    name: day,
                    total: data.total[day],
                });
            });
            this.setState({
                dailyTotal: total,
                dailyUnique: unique,
                loading: false,
            });
        });
    }

    onEnter() {
        if (this.state.id === this.props.merchantId) {
            return;
        }

        this.loadChart();
        Merchant.brands(this.props.merchantId).then((data) => {
            this.setState({
                brands: data,
                brandSelectionEnabled: data.length > 0,
                id: this.props.merchantId,
            });
        });
    }

    componentDidMount() {
        Emitter.on("MERCHANT_VOLUME", this.onEnter);
        Emitter.on("MERCHANT_RESET", () => {
            this.setState(this.initialState());
        });
    }

    componentWillUnmount() {
        Emitter.off("MERCHANT_VOLUME");
    }

    onChange(list) {
        if (list.length > 1) {
            list.splice(0, 1);
        }
        this.setState({
            brand: list,
        });
        if (list.length) {
            this.loadChart(list[0].value);
        } else {
            this.loadChart();
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <Container className="pt-4">
                    <Row
                        style={{
                            height: "100px",
                        }}
                    >
                        <Col>
                            <Loading />
                        </Col>
                    </Row>
                </Container>
            );
        }
        return (
            <Container className="pt-4">
                <Row>
                    <MultiSelect
                        id="brands"
                        disabled={!this.state.brandSelectionEnabled}
                        options={this.state.brands}
                        value={this.state.brand}
                        hasSelectAll={false}
                        onChange={this.onChange}
                        labelledBy="Select brand"
                    />
                </Row>
                <Row>
                    <Col
                        style={{
                            marginTop: "20px",
                        }}
                        className="d-flex align-items-center justify-content-center"
                    >
                        Unique Products
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex align-items-center justify-content-center text-center">
                        <AreaChart
                            width={900}
                            height={350}
                            data={this.state.dailyUnique}
                            margin={{ top: 0, right: 20, bottom: 5, left: 0 }}
                        >
                            <Area
                                type="monotone"
                                dataKey="total"
                                stroke="#8884d8"
                            />
                            <CartesianGrid
                                stroke="#ccc"
                                strokeDasharray="5 5"
                            />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                        </AreaChart>
                    </Col>
                </Row>
                <Row>
                    <Col
                        className="d-flex align-items-center justify-content-center"
                        style={{
                            marginTop: "20px",
                        }}
                    >
                        Offers
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex align-items-center justify-content-center text-center">
                        <AreaChart
                            width={900}
                            height={350}
                            data={this.state.dailyTotal}
                            margin={{ top: 0, right: 0, bottom: 0, left: 30 }}
                        >
                            <Area
                                type="monotone"
                                dataKey="total"
                                stroke="#8884d8"
                            />
                            <CartesianGrid
                                stroke="#ccc"
                                strokeDasharray="5 5"
                            />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                        </AreaChart>
                    </Col>
                </Row>
            </Container>
        );
    }
}

Volume.propTypes = {
    /** Merchant ID */
    merchantId: PropTypes.number.isRequired,
};

export default Volume;
